import React from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import FeatherIcon from 'feather-icons-react';
import {getRoleSliceColor} from '../../utils/chartColors';

const RoleDistributionDonutChart = ({data}) => {
  if (!data || data.length === 0) {
    return (
      <div className="empty-results mt-5">
        <FeatherIcon icon="info"/>
        <div className="empty-results-text">No role distribution data available</div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <PieChart>
        <Pie
          data={data}
          dataKey="percentage"
          nameKey="roleName"
          innerRadius="55%"
          outerRadius="80%"
          paddingAngle={2}
        >
          {data.map((entry, index) => (
            <Cell key={entry.roleId ?? entry.roleName} fill={getRoleSliceColor(entry.roleName, index)}/>
          ))}
        </Pie>
        <Tooltip formatter={(value, name) => [`${value}%`, name]} contentStyle={{fontSize: 12}} labelStyle={{fontWeight: 600}}/>
        <Legend wrapperStyle={{fontSize: 12}}/>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default RoleDistributionDonutChart;
